import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { DollarSign, TrendingUp, TrendingDown, Download, Calendar, Zap, Package, Percent, Truck, BarChart3 } from 'lucide-react';
export function RevenueAnalytics() {
  const monthlyData = [{
    month: 'Jul 2023',
    subscription: 25,
    serviceFee: 14.2,
    commission: 4.8,
    logistics: 10.5,
    total: 54.5
  }, {
    month: 'Agu 2023',
    subscription: 25,
    serviceFee: 15.1,
    commission: 5.1,
    logistics: 11.2,
    total: 56.4
  }, {
    month: 'Sep 2023',
    subscription: 25,
    serviceFee: 15.8,
    commission: 5.3,
    logistics: 11.8,
    total: 57.9
  }, {
    month: 'Okt 2023',
    subscription: 25,
    serviceFee: 16.8,
    commission: 5.4,
    logistics: 12.0,
    total: 59.2
  }];
  return <div className="space-y-6" data-id="element-3205">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-3206">
        <div data-id="element-3207">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-3208">
            Revenue Analytics
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-3209">
            Analisis pendapatan platform dan proyeksi pertumbuhan
          </p>
        </div>
        <div className="flex gap-2" data-id="element-3210">
          <select className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-3211">
            <option data-id="element-3212">Last 6 Months</option>
            <option data-id="element-3213">Last 12 Months</option>
            <option data-id="element-3214">Year to Date</option>
          </select>
          <Button variant="primary" icon={<Download className="w-4 h-4" data-id="element-3216" />} data-id="element-3215">
            Export Report
          </Button>
        </div>
      </div>

      {/* Revenue Breakdown by Source */}
      <div className="grid grid-cols-4 gap-4" data-id="element-3217">
        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-3218">
          <div className="flex items-center justify-between mb-3" data-id="element-3219">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3220">
              <Zap className="w-6 h-6 text-white" data-id="element-3221" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-3222">100%</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-3223">Subscription Fee</p>
          <p className="text-3xl font-bold text-green-900" data-id="element-3224">Rp 25Jt</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-3225">Stable MRR</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-3226">
          <div className="flex items-center justify-between mb-3" data-id="element-3227">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3228">
              <Package className="w-6 h-6 text-white" data-id="element-3229" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-3230">40%</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-3231">Service Fee</p>
          <p className="text-3xl font-bold text-blue-900" data-id="element-3232">Rp 16,8Jt</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-3233">+12% vs last month</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-3234">
          <div className="flex items-center justify-between mb-3" data-id="element-3235">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3236">
              <Percent className="w-6 h-6 text-white" data-id="element-3237" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-3238">
              30%
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-3239">Commission</p>
          <p className="text-3xl font-bold text-violet-900" data-id="element-3240">Rp 5,4Jt</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-3241">+8% vs last month</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-3242">
          <div className="flex items-center justify-between mb-3" data-id="element-3243">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3244">
              <Truck className="w-6 h-6 text-white" data-id="element-3245" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-3246">50%</Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-3247">Logistics Margin</p>
          <p className="text-3xl font-bold text-amber-900" data-id="element-3248">Rp 12Jt</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-3249">+15% vs last month</p>
        </Card>
      </div>

      {/* Monthly Trend */}
      <Card className="p-6" data-id="element-3250">
        <div className="flex items-center justify-between mb-6" data-id="element-3251">
          <div data-id="element-3252">
            <h3 className="font-bold text-lg text-slate-900" data-id="element-3253">
              Monthly Revenue Trend
            </h3>
            <p className="text-sm text-slate-500 mt-1" data-id="element-3254">
              Platform revenue breakdown by source
            </p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-3255">
          <table className="w-full" data-id="element-3256">
            <thead data-id="element-3257">
              <tr className="border-b border-slate-200" data-id="element-3258">
                <th className="text-left py-3 px-4 text-sm font-bold text-slate-700" data-id="element-3259">
                  Bulan
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-green-700" data-id="element-3260">
                  Subscription
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-blue-700" data-id="element-3261">
                  Service Fee
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-violet-700" data-id="element-3262">
                  Commission
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-amber-700" data-id="element-3263">
                  Logistics
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-3264">
                  Total
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-3265">
                  Growth
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-3266">
              {monthlyData.map((data, i) => {
              const prevTotal = i > 0 ? monthlyData[i - 1].total : data.total;
              const growth = ((data.total - prevTotal) / prevTotal * 100).toFixed(1);
              return <tr key={i} className="hover:bg-slate-50" data-id="element-3267">
                    <td className="py-3 px-4 font-medium text-slate-900" data-id="element-3268">
                      {data.month}
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-green-600" data-id="element-3269">
                      Rp {data.subscription}Jt
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-blue-600" data-id="element-3270">
                      Rp {data.serviceFee}Jt
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-violet-600" data-id="element-3271">
                      Rp {data.commission}Jt
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-amber-600" data-id="element-3272">
                      Rp {data.logistics}Jt
                    </td>
                    <td className="py-3 px-4 text-right font-bold text-slate-900" data-id="element-3273">
                      Rp {data.total}Jt
                    </td>
                    <td className="py-3 px-4 text-right" data-id="element-3274">
                      {i > 0 && <Badge variant={parseFloat(growth) > 0 ? 'success' : 'neutral'} data-id="element-3275">
                          {parseFloat(growth) > 0 ? <TrendingUp className="w-3 h-3 mr-1" data-id="element-3276" /> : <TrendingDown className="w-3 h-3 mr-1" data-id="element-3277" />}
                          {growth}%
                        </Badge>}
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Projections */}
      <div className="grid grid-cols-2 gap-6" data-id="element-3278">
        <Card className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-3279">
          <div className="flex items-center gap-3 mb-4" data-id="element-3280">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3281">
              <BarChart3 className="w-6 h-6 text-white" data-id="element-3282" />
            </div>
            <div data-id="element-3283">
              <h3 className="font-bold text-lg text-blue-900" data-id="element-3284">
                Revenue Projection
              </h3>
              <p className="text-sm text-blue-700" data-id="element-3285">Next 3 months</p>
            </div>
          </div>

          <div className="space-y-3" data-id="element-3286">
            <div className="flex justify-between items-center p-3 bg-white rounded-lg" data-id="element-3287">
              <span className="text-sm text-slate-600" data-id="element-3288">Nov 2023</span>
              <span className="font-bold text-blue-900" data-id="element-3289">Rp 61,5Jt</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-white rounded-lg" data-id="element-3290">
              <span className="text-sm text-slate-600" data-id="element-3291">Des 2023</span>
              <span className="font-bold text-blue-900" data-id="element-3292">Rp 63,8Jt</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-white rounded-lg" data-id="element-3293">
              <span className="text-sm text-slate-600" data-id="element-3294">Jan 2024</span>
              <span className="font-bold text-blue-900" data-id="element-3295">Rp 66,2Jt</span>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-blue-300" data-id="element-3296">
            <div className="flex justify-between items-center" data-id="element-3297">
              <span className="text-sm text-blue-700" data-id="element-3298">Avg Growth Rate</span>
              <span className="text-xl font-bold text-blue-900" data-id="element-3299">
                +4.2%/month
              </span>
            </div>
          </div>
        </Card>

        <Card className="p-6 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-3300">
          <div className="flex items-center gap-3 mb-4" data-id="element-3301">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-3302">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-3303" />
            </div>
            <div data-id="element-3304">
              <h3 className="font-bold text-lg text-green-900" data-id="element-3305">
                Annual Projection
              </h3>
              <p className="text-sm text-green-700" data-id="element-3306">Year 2024</p>
            </div>
          </div>

          <div className="space-y-4" data-id="element-3307">
            <div data-id="element-3308">
              <p className="text-sm text-green-700 mb-1" data-id="element-3309">
                Projected Annual Revenue
              </p>
              <p className="text-4xl font-extrabold text-green-900" data-id="element-3310">Rp 750Jt</p>
            </div>
            <div data-id="element-3311">
              <p className="text-sm text-green-700 mb-1" data-id="element-3312">Growth vs 2023</p>
              <p className="text-2xl font-bold text-green-900" data-id="element-3313">+45%</p>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-green-300" data-id="element-3314">
            <p className="text-xs text-green-700 mb-2" data-id="element-3315">Assuming:</p>
            <ul className="text-xs text-green-800 space-y-1" data-id="element-3316">
              <li data-id="element-3317">• 2 new agregators onboarded</li>
              <li data-id="element-3318">• 4% monthly transaction growth</li>
              <li data-id="element-3319">• Stable subscription fees</li>
            </ul>
          </div>
        </Card>
      </div>
    </div>;
}